export default [
  {
    path: '/order/movements',
    name: 'order-movements',
    component: () => import('../views/order/movements.vue')
  },
   {
    path: '/order/online',
    name: 'order-online',
    component: () => import('../views/order/online.vue')
  }
]
